import React, { useState } from "react"
import webify from "../util/webify"
import { Manager, Reference, Popper } from "react-popper"
import SVG from "react-inlinesvg"
import copySVG from "../../../priv/static/svg/generic/copy.svg"

interface InputWithCopyProps {
  value: string
  dataRole?: string
}

const copyToClipboard = (value: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(value)
  }
}

const InputWithCopy = (props: InputWithCopyProps) => {
  const { value } = props
  var [visible, setVisible] = useState(false)

  return (
    <div className="input-with-copy-component">
      <input
        type="text"
        disabled
        className="border-none rounded-none col-span-8 h-8 bg-gray-100"
        value={value}
        data-role={props.dataRole}
      />

      <Manager>
        <Reference>
          {({ ref }) => (
            <a
              className="col-span-1"
              title="Copy to clipboard"
              ref={ref}
              onClick={() => {
                setVisible(true)
                copyToClipboard(value)
                setTimeout(() => setVisible(false), 1500)
              }}
            >
              <SVG src={copySVG} className="h-4 w-4 mx-auto" />
            </a>
          )}
        </Reference>
        <Popper>
          {({ ref, style, placement, arrowProps }) =>
            visible && (
              <div
                className="copied-popover"
                ref={ref}
                onClick={(e) => e.stopPropagation()}
                style={style}
                data-placement={placement}
                data-role="tooltip-content"
              >
                <div>
                  <div className="copied-arrow " ref={arrowProps.ref} style={arrowProps.style} />
                  Copied!
                </div>
              </div>
            )
          }
        </Popper>
      </Manager>
    </div>
  )
}

export default InputWithCopy
webify("input-with-copy", InputWithCopy)
